import * as yup from "yup";

export const AssignDeviceValidation = yup.object({
    deviceName: yup.string().required(),
    assistantId: yup.string().required(),
});
